var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewtransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E85350;stroke:#060809;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#F1F1F1;stroke:#060809;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#FCD479;stroke:#060809;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#FCD479;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#F1F1F1;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1479.7,1262.3c0,130.1-105.5,235.5-235.6,235.5c-130.1,0-235.6-105.5-235.6-235.5 c0-130.1,105.5-235.6,235.6-235.6C1374.3,1026.7,1479.7,1132.2,1479.7,1262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1447,1262.3c0,112-90.8,202.8-202.8,202.8c-112,0-202.8-90.8-202.8-202.8c0-112.1,90.8-202.8,202.8-202.8 C1356.2,1059.4,1447,1150.2,1447,1262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1270.3,1463.2v-227.1H1218v227.1c8.6,1.1,17.3,1.9,26.2,1.9C1253,1465.1,1261.7,1464.3,1270.3,1463.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.8,1183.7h-52.4v252c16.2,9.8,33.7,17.3,52.4,22.3V1183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1060.9,1348.9c12.5,26.3,30.3,49.6,52.4,68.2v-102.5h-52.4V1348.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1427.4,1348.9v-86.6H1375v154.9C1397,1398.5,1414.9,1375.2,1427.4,1348.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1348.8,1131.4h-52.3V1458c18.6-5,36.2-12.5,52.3-22.3V1131.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 579.2,
    y: 1228.4,
    className: "st3",
    width: 130.8,
    height: 283.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "895.3,1446.4 895.3,1228.4 797.2,1228.4 797.2,1511.8 895.3,1511.8 895.3,1479.1 928,1479.1  928,1446.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 1097.6,
    className: "st3",
    width: 87.2,
    height: 130.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819,
    y: 1097.6,
    className: "st3",
    width: 76.3,
    height: 130.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "797.2,1511.8 797.2,1228.4 819,1228.4 819,1097.6 862.6,1097.6 862.6,977.7 644.6,977.7  644.6,1097.6 688.2,1097.6 688.2,1228.4 710,1228.4 710,1511.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M677.3,1021.3h152.6H677.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M677.3,1064.9h152.6H677.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720.9,1108.5h65.4H720.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720.9,1152.1h65.4H720.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720.9,1195.7h65.4H720.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M633.7,1228.3v-98.1V1228.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M655.5,1228.3v-98.1V1228.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M644.6,1511.8v-141.7V1511.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M611.9,1511.8v-141.7V1511.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M677.3,1511.8v-141.7V1511.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M644.6,1326.5v-43.6V1326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M611.9,1326.5v-43.6V1326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M677.3,1326.5v-43.6V1326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M851.7,1228.3v-98.1V1228.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M862.6,1511.8v-141.7V1511.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M829.9,1511.8v-141.7V1511.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M862.6,1326.5v-43.6V1326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M829.9,1326.5v-43.6V1326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M742.7,1239.3h21.8H742.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M742.7,1282.9h21.8H742.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M742.7,1326.5h21.8H742.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M742.7,1370.1h21.8H742.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M742.7,1413.7h21.8H742.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M742.7,1457.4h21.8H742.7z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 343.2,
    y: 342.4,
    className: "st6",
    width: 1312.6,
    height: 1312.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1266.1,648.7c4.4-0.4,8.9-0.7,13.3-0.7c81,0,146.7,65.7,146.7,146.7c0,81-65.7,146.6-146.7,146.6H752.9 c-99.4,0-180-80.6-180-179.9c0-99.5,80.6-180,180-180c14.3,0,28.2,1.9,41.6,5c27.2-102.6,120.5-178.3,231.6-178.3 c132.6,0,240,107.4,240,240C1266.1,648.3,1266.1,648.4,1266.1,648.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M786.2,648.1c0-21.4,3.1-42,8.3-61.7C789.3,606.1,786.2,626.7,786.2,648.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "720.4,809.4 753.3,760.2 786,809.4 753.3,760.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1376.9,1302.2 1327.7,1269.4 1376.9,1236.6 1327.7,1269.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M753.2,773.6v312V773.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1278.4,794.5h246.1c36.3,0,65.6,29.4,65.6,65.6v343.5v0c0,36.2-29.4,65.6-65.7,65.6l0,0.1h-196.9h196.9l0-0.1 c36.3,0,65.7-29.4,65.7-65.6v0V860.1c0-36.2-29.3-65.6-65.6-65.6H1278.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1098,565.6 901.1,565.6 901.1,841.2 1038.9,841.2 1098,782.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1098,782.1 1038.9,782.1 1038.9,841.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1279.5,648c-40.5,0-77.1,16.4-103.6,42.9C1202.4,664.4,1239,648,1279.5,648z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewtransaction);
export default __webpack_public_path__ + "static/media/viewtransaction.c35077452d5392455ac2256a3fe8fa7e.svg";
export { ForwardRef as ReactComponent };